import {
  buildShareLinks,
  buildSocialSharingOptions,
} from '@/features/shared/BlogMetaData/Sharing/utils';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { useMemo } from 'react';
import { AllSocialSharingOptionId } from './types';

const usePostShare = ({
  url,
  title,
  shareOptionsIds,
}: {
  url: string;
  title: string;
  shareOptionsIds: AllSocialSharingOptionId[];
}) => {
  const { texts } = useTranslation();

  const shareLinks = buildShareLinks({ url, title: title ?? '' });
  const allSocialSharingOptions = buildSocialSharingOptions(shareLinks, texts);
  const displayedSocialShareOptions = useMemo(
    () =>
      shareOptionsIds?.length
        ? allSocialSharingOptions.filter((option) =>
            shareOptionsIds.includes(option.id)
          )
        : allSocialSharingOptions,
    [shareOptionsIds, allSocialSharingOptions]
  );

  const shouldDisplayCopyButton = shareOptionsIds?.includes('copy');

  return {
    displayedSocialShareOptions,
    shouldDisplayCopyButton,
  };
};

export default usePostShare;
